import React, { useContext, useRef, useState } from 'react';

import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import md5 from 'md5';

import FireDataContext from '../../../services/firebase/FireDataContext';
import AuthContext from '../../../services/firebase/AuthContext';
import Button from '@material-ui/core/Button'
import Alert from '@material-ui/lab/Alert';
import MemberMiniMenu from '../menus/MemberMiniMenu';

const MemberInvitePage = () => {
    const { currentUser } = useContext(AuthContext);
    const db = useContext(FireDataContext);
    const emailRef = useRef();
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const invite = {
                roles: ['member'],
                invitedBy: {uid: currentUser.uid, email: currentUser.email },
                invitedAt: new Date().valueOf(),
                organization: 'WHuoyDs7zcB8wUU7euiC'
            };

            await db.update({
                path: `invitations/${md5(emailRef.current.value.toLowerCase())}`,
                payload: invite
            });

            setSuccess(true);
        }
        catch (error) {
            console.log('invitation error', error);
            setSuccess(false)
        }
    }

    return (
        <MemberMiniMenu>
            <Typography variant="h2" color="initial">Invite a new Intermediary Member 🙋</Typography>
            <Typography variant="body1">The sign-up page currently limits registration to people who've been invited. This is mainly to avoid spam registrations</Typography>
            <Typography variant="body1">At the moment we can't automatically send invites to people so you'll need to manually send them the URL to the sign-up page <strong>https://ti-coop.web.app//signup/member</strong></Typography>
            <Typography variant="body1">If all this is about as clear as custard just message me on Slack</Typography>
            <form noValidate onSubmit={handleSubmit}>
                <TextField
                    inputRef={emailRef}
                    variant="outlined"
                    margin="normal"
                    required
                    id="email"
                    label="Invitee Email Address"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    style={{minWidth: '25%'}}
                />      
                <div>
                    <Button variant="contained" color="secondary" type="submit" style={{marginTop: '0.5rem', minWidth: '25%'}}>
                    Authorise Invite
                    </Button>      
                </div>
            </form>
            {
                success && <Alert style={{marginTop: '1rem'}} severity="success">Okay! The invite has been created - just send them this <strong>https://ti-coop.web.app/signup</strong> link and they should be able to register</Alert>
            }
        </MemberMiniMenu>
    )
};

export default MemberInvitePage;